import { parseErrorBlock } from "../../utils/loanHelper";

const ErrorBlocks = ({ remaining }) => {
    if (!Array.isArray(remaining) || remaining.length === 0) return null;

    return (
        <div className="app-modal-errors" aria-live="polite" style={{ marginTop: "12px" }}>
            {remaining.map((blk, i) => {
                const { fieldToken, desc } = parseErrorBlock(blk);

                return (
                    <div
                        key={i}
                        className="app-modal-error-item"
                        style={{ marginBottom: "12px", textAlign: "left" }}
                    >
                        <div
                            className="app-modal-field"
                            style={{ fontFamily: "monospace", wordBreak: "break-all" }}
                        >
                            {fieldToken}
                        </div>

                        {desc ? (
                            <div className="app-modal-error-desc" style={{ marginTop: "6px" }}>
                                {desc}
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
};

export default ErrorBlocks;
